// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"551":"3f77ce23039c4dc0","1280":"42a526b7d4541495","9785":"db8a7fe793f9f54f"}[chunkId] + ".css";
};